export default {
  approvals: {
    validateRequest: 'Validar solicitud'
  }
}



// WEBPACK FOOTER //
// ./src/modules/approvals/lang/es.js